<template>
  <ez-modal class="holamundo" title :active.sync="active" classModal="w-1/2">
    <div class="vx-row m-0" v-if="attendance">
      <div class="vx-col p-5 w-full text-center text-2xl font-semibold text-black">
        <strong>Detail Presensi Tanggal {{moment(attendance.created_at).format("DD-MM-YYYY")}}</strong>
      </div>
      <div class="vx-col w-full mb-4">
        <div class="flex flex-col md:flex-row md:items-stretch">
        <div class="w-full">
          <div class="vx-col w-full py-2 flex text-lg">
            <div class="flex-initial pr-3">
              <vs-icon icon-pack="feather" size="small" color="primary" icon="icon-user" />
            </div>
            <div class="flex-1">
              <span class="font-semibold">Nama Petugas :</span><br> 
              {{attendance.user}} - {{attendance.initial}}
            </div>
          </div>
          <div class="vx-col w-full py-2 flex text-lg">
            <div class="flex-initial pr-3">
              <vs-icon icon-pack="feather" size="small" color="primary" icon="icon-clock" />
            </div>
            <div class="flex-1">
              <span class="font-semibold">Clock In :</span><br> 
              {{attendance.start_time ? 'Pukul '+attendance.start_time : '-'}}
            </div>
          </div>
          <div class="vx-col w-full py-2 flex text-lg">
            <div class="flex-initial pr-3">
              <vs-icon icon-pack="feather" size="small" color="primary" icon="icon-clock" />
            </div>
            <div class="flex-1">
              <span class="font-semibold">Clock Out :</span><br> 
              {{attendance.end_time ? 'Pukul '+attendance.end_time : '-'}}
            </div>
          </div>
          <div class="vx-col w-full py-2 flex text-lg">
            <div class="flex-initial pr-3">
              <vs-icon icon-pack="feather" size="small" color="primary" icon="icon-activity" />
            </div>
            <div class="flex-1">
              <span class="font-semibold">Status :</span><br>
              <AttendanceStatusChip :attendance="attendance"/>
            </div>
          </div>
          <div class="vx-col w-full py-2 flex text-lg" v-if="attendance.is_late">
            <div class="flex-initial pr-3">
              <vs-icon icon-pack="feather" size="small" color="primary" icon="icon-edit" />
            </div>
            <div class="flex-1">
              <span class="font-semibold">Alasan Terlambat :</span><br>
              {{attendance.reason_late ? attendance.reason_late : '---'}}
            </div>
          </div>
          <div class="vx-col w-full py-2 flex text-lg" v-if="attendance.is_early">
            <div class="flex-initial pr-3">
              <vs-icon icon-pack="feather" size="small" color="primary" icon="icon-edit" />
            </div>
            <div class="flex-1">
              <span class="font-semibold">Alasan Pulang Lebih Awal :</span><br>
              {{attendance.reason_early ? attendance.reason_early : '---'}}
            </div>
          </div>
          <vs-divider/>
          <div v-if="attendance.start_image || attendance.end_image" class="vx-col w-full py-2 flex text-lg mt-1">
            <div class="flex-1">
              <span class="font-semibold">File Pendukung :</span><br> 
              <vx-card class="w-full p-3 mt-3" v-if="attendance.start_image">
                <template #no-body>
                  <div class="flex flex-col">
                    <div class="w-full flex flex-col md:flex-row ">
                      <div class="flex items-center flex-1 mb-2 md:m-0">
                        <img :src="`/img/file-icons/jpg.png`" width="20px" alt="File" />
                        <div class="mx-4">
                          <p class="text-sm">Foto Clock In</p>
                        </div>
                      </div>
                      <div class="flex items-center justify-end ">
                        <vs-button
                        color="primary"
                        type="border"
                        icon="icon-download"
                        icon-pack="feather"
                        size="small"
                        :disabled="attendance.start_image == 'restricted'"
                        @click="downloadFile(attendance.start_image_url)"
                        >Download</vs-button>
                      </div>
                    </div>
                  </div>
                </template> 
              </vx-card>
              <vx-card class="w-full p-3 mt-3" v-if="attendance.end_image">
                <template #no-body>
                  <div class="flex flex-col">
                    <div class="w-full flex flex-col md:flex-row ">
                      <div class="flex items-center flex-1 mb-2 md:m-0">
                        <img :src="`/img/file-icons/jpg.png`" width="20px" alt="File" />
                        <div class="mx-4">
                          <p class="text-sm">Foto Clock Out</p>
                        </div>
                      </div>
                      <div class="flex items-center justify-end ">
                        <vs-button
                        color="primary"
                        type="border"
                        icon="icon-download"
                        icon-pack="feather"
                        size="small"
                        :disabled="attendance.end_image == 'restricted'"
                        @click="downloadFile(attendance.end_image_url)"
                        >Download</vs-button>
                      </div>
                    </div>
                  </div>
                </template> 
              </vx-card>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  </ez-modal>
</template>

<script>
import moment from "moment";
import AttendanceStatusChip from "@/components/chip/AttendanceStatusChip";

export default {
  components: {
    AttendanceStatusChip,
  },
  props: {
    active: {
      type: Boolean,
      required: true,
      default: false
    },
    attendanceId: {
      type: Number,
      required: false
    },
  },
  data(){
    return {
      attendance: {},
      moment: moment
    }
  },
  watch: {
    active(){
      if(this.active) {
        this.getAttendanceDetail();
      }
    }
  },
  methods: {
    getAttendanceDetail(){
      this.loading = true;
      this.$http.get(`/app/secure/attendance-info/detail/${this.attendanceId}`)
      .then(response => {
        this.loading = false;
        this.attendance = response.data.data.attendance;
      })
      .catch(error => {
        this.parseError(error);
      });
    },
    downloadFile(url) {
      window.open(url);
    }
  }
};
</script>